import { Injectable } from '@angular/core';
import { persistState, Store, StoreConfig } from '@datorama/akita';
import * as localForage from 'localforage';


const settingsStore = localForage.createInstance({
  name: 'patientLynk',
  storeName: 'settings_store'
});

persistState({ include: ['settings'], storage: settingsStore });

export interface SettingsState {
  patientLynkIntroPopup: {
     hasSeen?: boolean,
     dontShow?: boolean,
  };

  patientLynkOutroPopup: {
    hasSeen?: boolean,
    dontShow?: boolean,
  };
}

export function createInitialState(): SettingsState {
  return {
    patientLynkIntroPopup: {
      hasSeen: false,
      dontShow: false,
    },
    patientLynkOutroPopup: {
      hasSeen: false,
      dontShow: false,
    },
  };
}

@Injectable({ providedIn: 'root' })
@StoreConfig({ name: 'settings' })
export class SettingsStore extends Store<SettingsState> {

  constructor() {
    super(createInitialState());
  }

}
